<template>
  <div class="page page-single" v-if="init_done">
    <HeaderSlide />
    <div class="page-container">
      <el-breadcrumb separator="/">
        <el-breadcrumb-item :to="{ path: '/' }">首頁</el-breadcrumb-item>
        <el-breadcrumb-item>檢索結果</el-breadcrumb-item>
      </el-breadcrumb>
      <div class="page-title">
        檢索結果 <i class="fas fa-search"></i> <a accesskey="C" href="#content" title="content" class="accesskey-content" >:::</a>
        <template v-if="typeof series_title === 'string'">
          <span style="color: #3a7cc7; font-size: 18px; padding-left: 28px;">{{series_title}}</span>
        </template>
        <template style="display: inline;" v-if="frontstage_search_keyword!==''">
          <span style="color: #3a7cc7; font-size: 18px; padding-left: 28px;">{{frontstage_search_keyword}}</span>
          <span style="font-size: 13px; color: #888; padding-left: 10px;"><i class="fa fa-tag" aria-hidden="true"></i>
          共 <span id="total_found" class="show-total-found">{{article_total}}</span>筆
          </span>
        </template>
      </div>
      <div class="page-content page-content--2cols">
        <div class="page-content-left">
          <div class="page-content-box">
            <div class="page-content-title">
              <span><i class="fas fa-filter"></i> 過濾條件</span>
            </div>
            <el-collapse v-model="filterCollapse">
              <el-collapse-item
                title="全宗 / 次全宗" 
                name="1"
              >
                <el-tree 
                  :data="the_tree" 
                  :props="tree_props" 
                  node-key="uuid"
                  @check-change="handle_tree_check_change"
                  show-checkbox
                  ref="tree"
                >
                </el-tree>
              </el-collapse-item>
              <el-collapse-item
                v-for="(category, idx) in this.categories" :key="idx" 
                :title="category.info.title" 
                :name="idx.toString()"
              >
                <ul>
                  <li>
                    <el-checkbox-group v-model="category.checked">
                        <div
                            v-for="(sub_category, idx) in category.available" 
                            :key="idx"
                        >
                            <el-checkbox 
                                :label="sub_category.key" 
                                :key="sub_category.key"
                            >
                                {{sub_category.name}} ({{sub_category.count}})
                            </el-checkbox>
                        </div>
                    </el-checkbox-group>
                  </li>
                </ul>
              </el-collapse-item>

              <el-collapse-item 
                v-show="this.activeTab === 'list' || this.activeTab === 'pic'"
                title="時間區間(創建時間)" name="3"
              >
                <ul>
                  <li>
                    <el-date-picker v-model="filter['created_time_start']" type="date" placeholder="選擇起始日期" value-format="yyyy-MM-dd"></el-date-picker>
                    <el-date-picker v-model="filter['created_time_end']" type="date" placeholder="選擇結束日期" value-format="yyyy-MM-dd"></el-date-picker>
                  </li>
                </ul>
              </el-collapse-item>
            </el-collapse>
            <div class="page-content-left-actions">
              <el-button type="primary" @click="handle_category_button_clicked">篩選</el-button>
              <el-button @click="handle_clean_category_button_clicked">清空</el-button>
            </div>
          </div>
          <div class="page-content-box">
            <div class="page-content-title">
              <span><i class="fas fa-filter"></i> 其他館藏資源</span>
            </div>
            <ul class="links">
              <li
                v-for="(link, idx) in collection_links"
                :key="idx"
              >
                <a @click="()=>handle_link_clicked(link)">
                  <span class="link">{{link.title}}</span>
                </a>
              </li>
            </ul>
          </div>
        </div>
        <div class="page-content-right">
          <el-tabs type="card" v-model="activeTab">
            <ArticleMap 
                v-if="activeTab === 'space'"
                :locations="article_coordinate_list"
            />
            <el-tab-pane name="list">
              <span slot="label"><i class="fas fa-list"></i> 列表檢視</span>
              <el-row>
                <el-col :span="12" >
                  <el-select size="small" @change="update_view" v-model="sortValue" placeholder="請選擇排序">
                    <el-option v-for="item in sortOptions" :key="item.value" :label="item.label" :value="item.value">
                    </el-option>
                  </el-select>
                </el-col>
              </el-row>
              <ul class="data-list data-list--normal">
                <li class="data-item" 
                    v-for="(article, idx) in article_list"
                    :key="idx"
                >
                  <div class="image"><img
                      :src="`${APP}/${article['cover_image_path']}`"
                      alt=""></div>
                  <a :href="`/article/${article['system_id']}`" class="title">{{article['title']}}</a>
                  <div v-for="(keyword, idx) in article['keywords']" :key="idx" class="cat1">{{keyword}}</div>
                </li>
              </ul>
              <el-pagination 
                class="align-center" 
                @size-change="handle_page_size_change"
                @current-change="handle_current_page_change"
                :current-page="page_num" 
                :page-sizes="[10,20,50]"
                :page-size="page_limit"
                layout="total, prev, pager, next, sizes, jumper " 
                :total="article_total" 
                background
              >
              </el-pagination>
            </el-tab-pane>
            <el-tab-pane name="pic">
              <span slot="label"><i class="fas fa-th"></i> 圖片檢視</span>
              <el-row>
                <el-col :span="12" >
                  <el-select size="small" @change="update_view" v-model="sortValue" placeholder="請選擇排序">
                    <el-option v-for="item in sortOptions" :key="item.value" :label="item.label" :value="item.value">
                    </el-option>
                  </el-select>
                </el-col>
              </el-row>
              <ul class="data-list data-list--image">
                <li 
                    class="data-item"
                    v-for="(article, idx) in article_list"
                    :key="idx"
                >
                  <a :href="`/article/${article['system_id']}`" class="data-link">
                    <div class="image"><img
                        :src="`${APP}/${article['cover_image_path']}`"
                        alt=""></div>
                    <div class="title" :title="article['title']">{{article['title']}}</div>
                    <div v-for="(keyword, idx) in article['keywords'].slice(0,2)" :key="idx" class="cat1">{{keyword}}</div>
                    <div v-for="(word, idx) in get_keywords_padding(article['keywords'])" :key="`${idx}${word}`" v-html="word"></div>
                  </a>
                </li>
              </ul>
              <el-pagination 
                class="align-center" 
                @size-change="handle_page_size_change"
                @current-change="handle_current_page_change"
                :current-page="page_num" 
                :page-sizes="[10,20,50]"
                :page-size="page_limit"
                layout="total, prev, pager, next, sizes, jumper " 
                :total="article_total" 
                background
              >
              </el-pagination>
            </el-tab-pane>
            <el-tab-pane name="time">
              <span slot="label"><i class="fas fa-clock"></i> 時間檢視</span>
              <el-timeline class="data-list data-list--normal data-list--inline-block">
                <el-timeline-item 
                    v-for="(articles_in_a_year, idx) in article_timeline_list"
                    :key="idx"
                    placement="top" 
                    :timestamp="articles_in_a_year['year']"
                >
                  <li class="data-item"
                    v-for="(article, inner_idx) in articles_in_a_year['articles']"
                    :key="inner_idx"
                  >
                    <div class="image"><img
                        :src="`${APP}/${article['cover_image_path']}`"
                        alt=""></div>
                    <a :href="`/article/${article['system_id']}`" class="title">{{article['title']}}</a>
                    <div class="des">{{article['abstract']}}</div>
                  </li>
                </el-timeline-item>
              </el-timeline>
            </el-tab-pane>
            <el-tab-pane name="space">
              <span slot="label"><i class="fas fa-map-marker-alt"></i> 空間檢視</span>
              <ul class="data-list data-list--normal">
                <li class="data-item" 
                    v-for="(article, idx) in article_coordinate_list"
                    :key="idx"
                >
                  <div class="image"><img
                      :src="`${APP}/${article['cover_image_path']}`"
                      alt=""></div>
                  <a :href="`/article/${article['system_id']}`" class="title">{{article['title']}}</a>
                  <div v-for="(keyword, idx) in article['keywords']" :key="idx" class="cat1">{{keyword}}</div>
                </li>
              </ul>
            </el-tab-pane>
          </el-tabs>
        </div>
      </div>
    </div>
    <LoadingBlock
        :active="loading > 0">
    </LoadingBlock>
  </div>
</template>

<script>
import HeaderSlide from '@/components/frontstage/HeaderSlide.vue';
import ArticleMap from './collection/ArticleMap.vue';
import api from '@/api/frontstage'
import axios from 'axios'
import frontstageSearchMixin from '@/mixins/frontstageSearchMixin'
import LoadingBlock from '@/components/backstage/LoadingBlock/LoadingBlock.vue'


  export default {
    name: 'list',
    mixins: [
      frontstageSearchMixin
    ],
    components: {
      HeaderSlide,
      ArticleMap,
      LoadingBlock
    },
    watch: {
        frontstage_search_keyword (val) {
            this.update_view()
        }
    },
    async created () {
      this.init()
    },
    data() {
      return {
        APP: process.env.VUE_APP_URL,
        activeTab: 'list',
        filterCollapse: ['0', '1', '2', '3'],
        sortOptions: [{
          value: 'article_created_time_asc',
          label: '依創建時間排序(舊到新)'
        }, {
          value: 'article_created_time_desc',
          label: '依創建時間排序(新到舊)'
        }],
        sortValue: 'article_created_time_desc',

        category_info: {
          endpoint: 'article/post-classification/list',
          categories: [
            // {
            //   title: '全宗',
            //   display: {
            //     name: 'recordgroup_name',
            //     type: 'string',
            //   },
            //   filter: {
            //     key: 'fk_recordgroup_id',
            //     type: 'string'
            //   },
            // },
            {
              title: '類型',
              display: {
                name: 'series_name',
                type: 'string',
              },
              filter: {
                key: 'series_number',
                type: 'string'
              },
            },
          ]
        },
        categories: [],
        the_tree: [],
        tree_props: {
          children: 'children',
          label: 'label'
        },
        checked_tree_nodes: [],
        filter: {
            created_time_start: null,
            created_time_end: null
        },
        
        article_list: [],
        article_timeline_list: [],
        article_coordinate_list: [],
        page_num: 1,
        page_limit: 10,
        article_total: 0,
        series_number: null,
        series_title: null,
        loading: 0,
        init_done: false
      }
    },
    methods: {
        async init () {
          console.log('Collection: created, route.query=', this.$route.query)

          if (this.frontstage_filter_series_number) {
            this.clear_frontstage_search_keyword()
          }

          if (this.category_info) {
              this.categories = []
              this.category_info['categories'].forEach((category) => {
                  this.categories.push({
                      available: [],
                      checked: [],
                      count: 0,
                      info: category,
                  })
              })
              console.log('Collection::created(): category_info:', this.category_info)
          }

          await this.update_view()
          
          if (this.frontstage_filter_series_number) {
            this.clear_frontstage_filter_series_number()
          }
          this.init_done = true
      },
      get_keywords_padding(keywords) {
        if (keywords.length === 0) {
          return ['&nbsp;','&nbsp;','&nbsp;']
        }
        else if (keywords.length === 1) {
          return ['&nbsp;','&nbsp;']
        }
        else if (keywords.length === 2) {
          return ['&nbsp;']
        }
        else {
          return ['...']
        }
      },
      async update_article_list() {
        let params = this.get_serach_params()
        let params_no_time = this.get_serach_params_without_time()

        // home page series_number selector
        this.series_number = this.frontstage_filter_series_number
        this.series_title = this.frontstage_filter_series_title
        console.log('series_title:', this.series_title)

        this.loading += 1
        let res = await api.get_article_list(params)
        this.loading -= 1
        if (res.success) {
          console.log('[前臺] article list: ', res)
          res['payload']['payload']['search_result'].forEach(function (article) {
              article['keywords'] = article['keywords'].split(';')
              if (article['cover_image'][0] && article['cover_image'][0]['path']) {
                  article['cover_image_path'] = article['cover_image'][0]['path']
              }
              else {
                  article['cover_image_path'] = null
              }
          })
          this.$set(this, 'article_list', res['payload']['payload']['search_result'])
          this.article_total = res['payload']['payload']['search_count']
        }
        else {
          this.$set(this, 'article_list', [])
          this.article_total = 0
          this.notify_message(this.ERROR.LEVEL.ERROR, '無法取得列表', res.message)
        }

        this.loading += 1
        res = await api.get_article_timeline_list(params_no_time)
        this.loading -= 1
        if (res.success) {
          console.log('[前臺] article timeline list: ', res)
          res['payload']['payload']['search_result'].forEach(function (year) {
              year['articles'].forEach(function(article) {
                if (article['cover_image'] && article['cover_image'][0] && article['cover_image'][0]['path']) {
                  article['cover_image_path'] = article['cover_image'][0]['path']
                }
                else {
                  article['cover_image_path'] = null
                }
              })
          })
          this.$set(this, 'article_timeline_list', res['payload']['payload']['search_result'])
        }
        else {
          this.$set(this, 'article_timeline_list', [])
          this.notify_message(this.ERROR.LEVEL.ERROR, '無法取得列表', res.message)
        }

        this.loading += 1
        res = await api.get_article_coordinate_list(params_no_time)
        this.loading -= 1
        if (res.success) {
          res['payload']['payload']['search_result'].forEach(function (article) {
              article['keywords'] = article['keywords'].split(';')
              if (article['cover_image'][0] && article['cover_image'][0]['path']) {
                  article['cover_image_path'] = article['cover_image'][0]['path']
              }
              else {
                  article['cover_image_path'] = null
              }
          })
          console.log('[前臺] article coordinate list: ', res)
          this.$set(this, 'article_coordinate_list', res['payload']['payload']['search_result'])
        }
        else {
          this.$set(this, 'article_coordinate_list', [])
          this.notify_message(this.ERROR.LEVEL.ERROR, '無法取得列表', res.message)
        }
      },
      handle_page_size_change (size) {
        this.page_limit = size
        this.page_num = 1
        this.update_article_list()
      },
      handle_current_page_change (page) {
        this.page_num = page
        this.update_article_list()
      },
      get_serach_params: function () {
        let params = {}

        // time range
        if (this.filter['created_time_start'] && this.filter['created_time_end']) {
            params['article_created_time'] = {
                'value': [
                    this.filter['created_time_start'] + ' 00:00:00',
                    this.filter['created_time_end'] + ' 23:59:59',
                ],
                'action': 'between'
            }
        }
        else if (this.filter['created_time_start']) {
            params['article_created_time'] = {
                'value': this.filter['created_time_start'] + ' 00:00:00',
                'action': '>='
            }
        }
        else if (this.filter['created_time_end']) {
            params['article_created_time'] = {
                'value': this.filter['created_time_end'] + ' 23:59:59',
                'action': '<='
            }
        }

        // sort
        params['sort'] = this.sortValue

        // search
        if (this.frontstage_search_keyword) {
            params['fulltext'] = {
                'value': this.frontstage_search_keyword.split(' '),
                'action': 'in'
            }
        }

        // pagination
        params['page_num'] = this.page_num
        params['page_limit'] = this.page_limit

        // categories
        if (this.frontstage_filter_series_number) {
          params['series_number'] = {
            value: [this.frontstage_filter_series_number],
            action: 'in'
          }
        }
        else {
          for (let category of this.categories) { 
            params[category['info']['filter']['key']] = {
                'value': category['checked'],
                'action': 'in'
            }
          }
        }

        // tree (全宗/次全宗)
        if (typeof params['fk_recordgroup_id'] === 'undefined') {
          params['fk_recordgroup_id'] = {
            'value': [],
            'action': 'in'
          }
        }
        if (typeof params['fk_sub_recordgroup_id'] === 'undefined') {
          params['fk_sub_recordgroup_id'] = {
            'value': [],
            'action': 'in'
          }
        }
        for(let i = 0; i < this.checked_tree_nodes.length; i++) {
          let node = this.checked_tree_nodes[i]

          // if (typeof node['fk_recordgroup_id'] === 'number') {
          //   params['fk_recordgroup_id']['value'].push(node['fk_recordgroup_id'])
          // }
          // else 
          if (typeof node['fk_sub_recordgroup_id'] === 'number') {
            params['fk_sub_recordgroup_id']['value'].push(node['fk_sub_recordgroup_id'])
          }
        }
        
        return params
      },
      get_serach_params_without_time: function () {
          let params = this.get_serach_params()
          delete params.article_created_time
          delete params.sort
          return params
      },
      update_view : function () {
        this.update_article_list()
        this.update_categories()
      },
      update_categories () {
        if (!this.category_info) {
            return
        }

        if (this.category_info && !this.category_info['endpoint']) {
            console.log('err: Collection: no category list endpoint')
            return
        }

        console.log('Collection: category endpoint:' + this.category_info['endpoint'])

        let params = this.get_serach_params()
        console.log('Collection: update_categories, param: ', params)

        this.loading += 1
        axios.post(process.env.VUE_APP_API_URL+'/'+this.category_info['endpoint'], params) 
            .then((response) => {
                this.loading -= 1
                console.log('Collection: category reponse: ', response.data.payload)

                this.categories.forEach((category) => {
                    category.available = []
                    category.count = 0
                    if (typeof response.data.payload['search_result'] !== 'undefined' && response.data.payload['search_result']!== null) {
                        response.data.payload['search_result'][category['info']['filter']['key']].forEach((sub_category) => {
                            let name = ''
                            if (sub_category[category['info']['display']['name']] === null) {
                                name = '(無值)'
                            }
                            else if (sub_category[category['info']['display']['name']] === '') {
                                name = '(空白字串)'
                            }
                            else {
                                name = sub_category[category['info']['display']['name']]
                            }
                            category.available.push({
                                name: name,
                                key: sub_category[category['info']['filter']['key']],
                                count: sub_category['amount']
                            })
                            category.count += sub_category['amount']
                        })
                    }
                })

                if (typeof response.data.payload['search_result'] !== 'undefined' && response.data.payload['search_result']!== null) {
                  let tree_data = JSON.parse(JSON.stringify(response.data.payload['search_result']['fk_recordgroup_id']))

                  // rename fk_recordgroup_id to children for tree structure
                  let fill_children = (arr) => {
                    for (let i = 0; i < arr.length; i++) {
                      let element = arr[i]
                      if (Array.isArray(element['fk_sub_recordgroup_id'])) {
                        element['children'] = element['fk_sub_recordgroup_id']
                      }
     
                      if (Array.isArray(element['children'])) {
                        fill_children(element['children'])
                      }
                    }
                  }
                  fill_children(tree_data)

                  let fill_name = (arr) => {
                    for (let i = 0; i < arr.length; i++) {
                      let element = arr[i]
                      if (typeof element['recordgroup_name'] === 'string') {
                        element['label'] = element['recordgroup_name']
                      }
                      else if (typeof element['sub_recordgroup_name'] === 'string') {
                        element['label'] = element['sub_recordgroup_name']
                      }

                      element['label'] += ' (' + element['amount'] + ')'

                      if (Array.isArray(element['children'])) {
                        fill_name(element['children'])
                      }
                    }
                  }
                  fill_name(tree_data)

                  let fill_uuid = (arr) => {
                    for (let i = 0; i < arr.length; i++) {
                      let element = arr[i]
                      if (typeof element['fk_recordgroup_id'] === 'number') {
                        element['uuid'] = element['fk_recordgroup_id'] + '-x'
                      }
                      else if (typeof element['fk_sub_recordgroup_id'] === 'number') {
                        element['uuid'] = 'x-' + element['fk_sub_recordgroup_id']
                      }

                      if (Array.isArray(element['children'])) {
                        fill_uuid(element['children'])
                      }
                    }
                  }
                  fill_uuid(tree_data)

                  let preserved_checked_tree_nodes = JSON.parse(JSON.stringify(this.checked_tree_nodes))
                  this.$set(this, 'the_tree', tree_data)

                  if (Array.isArray(preserved_checked_tree_nodes) && preserved_checked_tree_nodes.length > 0) {
                    setTimeout(
                      () => {
                        // console.log('set checked nodes:', preserved_checked_tree_nodes)
                        this.$refs.tree.setCheckedNodes(preserved_checked_tree_nodes)
                      },
                      300
                    )
                  }
                }
              
                console.log('Collection: categories:', this.categories)

            })
            .catch(err => {
                this.loading -= 1
                console.log(err)
                this.notify_message(this.ERROR.LEVEL.ERROR, '無法取得分類', this.ERROR.MSG.general_err_msg)
            })
      },
      handle_category_button_clicked () {
            console.log('Collection: category button clicked, categories:', this.categories)
            this.current_page = 1
            this.update_view()
      },
      handle_clean_category_button_clicked () {
            for (let category of this.categories) {
                category['checked'] = []
            }
            this.checked_tree_nodes = []
            this.filter['created_time_start'] = null
            this.filter['created_time_end'] = null
            this.current_page = 1
            this.update_view()
      },
      async handle_link_clicked (link) {
        this.update_frontstage_filter_series_number(link['series_number'])
        this.init_done = false
        await this.$nextTick()
        this.init()
      },
      handle_tree_check_change(data, checked, indeterminate) {
        // console.log('check changed:', data, checked, indeterminate);
        // console.log('checked nodes: ', this.$refs.tree.getCheckedNodes());
        // console.log('checked keys: ', this.$refs.tree.getCheckedKeys());
        this.$set(this, 'checked_tree_nodes', this.$refs.tree.getCheckedNodes())
      },
    }
  }
</script>
<style lang="scss" scoped>
  .toolbar {
    margin-bottom: 16px;
    /deep/.el-button {
      width: 40px;
      height: 40px;
      text-align: center;
      line-height: 40px;
      padding: 0;
    }
  }

  .social-sharing {
    margin-left: 11px;
    cursor: pointer;
  }

  .link {
    margin-left: 11px;
    cursor: pointer;
  }

  .accesskey-content{
    color: white;
  }
</style>
